import React from 'react';

const ChatHeader = ({ isWidget = false }) => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white p-4 rounded-t-lg">
      <div className="flex items-center">
        <div className={`${isWidget ? 'w-8 h-8' : 'w-10 h-10'} rounded-full bg-white flex items-center justify-center mr-3`}>
          <svg xmlns="http://www.w3.org/2000/svg" className={`${isWidget ? 'h-5 w-5' : 'h-6 w-6'} text-blue-600`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4" />
          </svg>
        </div>
        <div>
          <h2 className={`${isWidget ? 'text-lg' : 'text-xl'} font-bold`}>CloudPlexo AI Assistant</h2>
          <p className="text-xs opacity-75">Cloud Solutions & Support</p>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;